import DashboardRounded from "@mui/icons-material/DashboardRounded";
import FolderRounded from "@mui/icons-material/FolderRounded";
import AccountTreeRounded from "@mui/icons-material/AccountTreeRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import WorkspacesRounded from "@mui/icons-material/WorkspacesRounded";
import ListAltRounded from "@mui/icons-material/ListAltRounded";
import StraightenRounded from "@mui/icons-material/StraightenRounded";
import Inventory2Rounded from "@mui/icons-material/Inventory2Rounded";
import PeopleAltRounded from "@mui/icons-material/PeopleAltRounded";
import { matchPath } from "react-router-dom";

export const dashboardItem = {
  label: "Dashboard",
  to: "/dashboard",
  icon: DashboardRounded,
  matchPaths: ["/", "/dashboard"],
};

export const navSections = [
  {
    title: "Attribute Management",
    items: [
      {
        label: "Groups",
        to: "/groups",
        icon: FolderRounded,
        matchPaths: ["/groups", "/groups/*", "/group/edit/*"],
      },
      {
        label: "Classes",
        to: "/classnew",
        icon: AccountTreeRounded,
        matchPaths: ["/classnew", "/classes", "/classes/*", "/class/edit/*"],
      },
      {
        label: "Features",
        to: "/featuresnew",
        icon: TuneRounded,
        matchPaths: ["/featuresnew", "/features/*", "/feature/edit/*"],
      },
      {
        label: "Feature Grouping",
        to: "/featuregroups",
        icon: WorkspacesRounded,
        matchPaths: [
          "/featuregroups",
          "/featuregroups/*",
          "/featuregroup/edit/*",
        ],
      },
      {
        label: "Values",
        to: "/valuesnew",
        icon: ListAltRounded,
        matchPaths: ["/valuesnew", "/values", "/values/*", "/value/edit/*"],
      },
      {
        label: "Units",
        to: "/unitsnew",
        icon: StraightenRounded,
        matchPaths: ["/unitsnew", "/units", "/units/*", "/unit/edit/*"],
      },
    ],
  },
  {
    title: "360 View",
    items: [
      {
        label: "Product",
        to: "/product",
        icon: Inventory2Rounded,
        matchPaths: ["/product", "/product/*"],
      },
      {
        label: "Customer",
        to: "/customers",
        icon: PeopleAltRounded,
        matchPaths: ["/customers", "/customers/*"],
      },
    ],
  },
];

export const allNavItems = [dashboardItem, ...navSections.flatMap((s) => s.items)];

export const isNavItemActive = (item, pathname) =>
  item.matchPaths.some((p) => matchPath({ path: p, end: true }, pathname));

export const getPageTitle = (pathname) =>
  allNavItems.find((item) => isNavItemActive(item, pathname))?.label ?? "";
